export const HIERARCHY_GRADES_ENUM = {
  PRE_K: 'PRE_K',
  KINDERGARTEN: 'KINDERGARTEN',
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
  FOURTH: 'FOURTH',
  FIFTH: 'FIFTH',
  SIXTH: 'SIXTH',
  SEVENTH: 'SEVENTH',
  EIGHTH: 'EIGHTH',
  NINTH: 'NINTH',
  TENTH: 'TENTH',
  ELEVENTH: 'ELEVENTH',
  TWELFTH: 'TWELFTH',
};

export const HIERARCHY_GRADES_ORDINAL_ENUM = {
  PRE_K: 'PRE_K',
  KINDERGARTEN: 'KINDERGARTEN',
  '1st': 'FIRST',
  '2nd': 'SECOND',
  '3rd': 'THIRD',
  '4th': 'FOURTH',
  '5th': 'FIFTH',
  '6th': 'SIXTH',
  '7th': 'SEVENTH',
  '8th': 'EIGHTH',
  '9th': 'NINTH',
  '10th': 'TENTH',
  '11th': 'ELEVENTH',
  '12th': 'TWELFTH',
};
